import {
  AppstoreOutlined,
  AuditOutlined,
  UserOutlined,
  // ProjectOutlined,
  NotificationOutlined,
  ContactsOutlined
} from "@ant-design/icons";

const Drawer = [
  {
    title: "خانه",
    icon: <AppstoreOutlined className="f-20" />,
    url: "/",
  },
  // {
  //   title: "دسته بندی",
  //   icon: <ProjectOutlined className="f-20" />,
  //   url: "/categories",
  // },
  {
    title: "ورود / عضویت",
    icon: <UserOutlined className="f-20" />,
    url: "/login",
    auth: false,
  },
  {
    title: "سفارشات من",
    icon: <AuditOutlined className="f-20" />,
    url: "/profile/orders",
    auth: true,
  },
  {
    title: "آدرس های من",
    icon: <AuditOutlined className="f-20" />,
    url: "/profile/addresses",
    auth: true,
  },
  {
    title: "لیست پرداختی ها",
    icon: <AuditOutlined className="f-20" />,
    url: "/profile/transactions",
    auth: true,
  },
  {
    title: "پروفایل",
    icon: <UserOutlined className="f-20" />,
    url: "/profile",
    auth: true,
  },
  {
    title: "تماس با ما",
    icon: <ContactsOutlined className="f-20" />,
    url: "/contact",
    auth: true,
  },
  {
    title: "قوانین مقررات",
    icon: <NotificationOutlined className="f-20" />,
    url: "/faq",
  },
];

export default Drawer;
